export { subscribeToAndroidEdgeBack } from "#android-edge-back";
